import React from 'react'
import PropTypes from 'prop-types'
import MakeModelSearchBar from 'components/MakeModelSearchBar'
import { VEHICLE_TYPE, COOKIES } from '@/utils/constants'
import {
  getCookie,
  generateLocationLeftHand,
  generateLocationRightHand,
  generateFilterLocationFromCookie,
} from 'utils/utils'

import { cookieCategoryIsActive } from '@/modern/utils/cookies'

const SearchBar = ({
  fetchAutoComplete,
  vehicleType,
  autoCompleteCar,
  autoCompleteBike,
  cookieNoticeContext,
  responsive,
}) => {
  if (!fetchAutoComplete || typeof fetchAutoComplete !== 'function') return null

  function getCookieLocation() {
    const { cookies } = cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.FILTER_SEARCH
    )

    // gera no padrão do filtro ('Campinas - SP' ou "São Paulo" ou vazio para Brasil)
    let searchCookie =
      isCookieCategoryActive && getCookie(COOKIES.FILTER_SEARCH)
    if (
      searchCookie &&
      typeof searchCookie === 'string' &&
      searchCookie.indexOf('{') === 0
    ) {
      searchCookie = JSON.parse(searchCookie)
    }
    let cookieLocation =
      searchCookie !== undefined && searchCookie.estadocidade !== undefined
        ? searchCookie.estadocidade
        : 'estoque'
    cookieLocation = decodeURIComponent(cookieLocation)
    return generateFilterLocationFromCookie(cookieLocation)
  }

  const autoCompleteSource =
    vehicleType === VEHICLE_TYPE.car ? autoCompleteCar : autoCompleteBike
  const message =
    vehicleType === VEHICLE_TYPE.car
      ? 'Digite marca ou modelo do carro'
      : 'Digite marca ou modelo da moto'

  const locationLeft =
    generateLocationLeftHand(getCookieLocation()) || 'estoque'
  const locationRight =
    generateLocationRightHand(getCookieLocation()) || 'estoque'

  return (
    <MakeModelSearchBar
      responsive={responsive}
      search={{ source: autoCompleteSource, fetched: true }}
      placeholder={message}
      vehicleRoute={VEHICLE_TYPE[vehicleType.toUpperCase()]}
      locationLeft={locationLeft}
      locationRight={locationRight}
      vehicleType={vehicleType}
      className=" SearchBar--searchResult"
      fetchAutoComplete={fetchAutoComplete}
    />
  )
}

SearchBar.defaultProps = {
  fetchAutoComplete: () => null,
  vehicleType: '',
  autoCompleteCar: {},
  autoCompleteBike: {},
  cookieNoticeContext: {},
  responsive: {},
}

SearchBar.propTypes = {
  fetchAutoComplete: PropTypes.func,
  vehicleType: PropTypes.string,
  autoCompleteCar: PropTypes.oneOfType([PropTypes.object]),
  autoCompleteBike: PropTypes.oneOfType([PropTypes.object]),
  cookieNoticeContext: PropTypes.oneOfType([PropTypes.object]),
  responsive: PropTypes.oneOfType([PropTypes.object]),
}

export default SearchBar
